<template>
  <div class="body">
    <div class="company">

      <div class="contetn" v-for="(i, index) in this.orgsTree" :key="index">
        <div class="filtertitle">
          <el-input placeholder="输入关键字按回车查询" v-model="filterText" @keyup.enter.native="searchChild"
            style="width: 200px;margin: 20px;">
          </el-input>
          <div>
            <!-- {{ i.name || i.id }} -->
          </div>
          <div style="font-size: 16px;">
            登录用户:{{ username }}
          </div>
        </div>
        <div class="boten">

          <div v-for=" (vd, K) in i.children " :key="K" class="conten-body" @click="handleNodeClick(vd)">
            <div class="bobobo">
              <div>
                {{ vd.name || '' }}
              </div>
              <div style="position: absolute;bottom: 0px;right: 6px;border-radius: 50%;">
                <i class="el-icon-s-shop" style="font-size: 40px;color:rgba(16,89,214, 0.7);background-color: #fff;"></i>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>
<script>
import {
  listToTreeSelect
} from '@/utils'
import {
  mapGetters
} from 'vuex'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import * as accsssObjs from '@/api/accessObjs'
import * as users from '@/api/users'
import * as apiRoles from '@/api/roles'
import * as login from '@/api/login'
import { json } from '../dlvueprint/templates/template-files/template1'
import { watch } from 'vue'
export default {
  name: 'orginfo',
  data() {
    return {
      selectedorgId: '',
      orgTreeProps: { // tree配置项
        children: 'children',
        label: 'label'
      },
      listLoading: true,
      orgs: [], // 用户可访问到的组织列表
      orgsTree: [], // 用户可访问到的所有机构组成的树
      currentOrg: {},
      includeOrgs: [{ orgId: '-1', orgName: "不限" }],
      includeDepts: [],
      temp: {
        account: '',
        name: '',
        sex: 0
      },
      filterText: '',
      newpwd: '',
      username: window.localStorage.getItem('username')

    }

  },
  props: {
    org: [],
    type: Array
  },
  methods: {
    enterPage: function () {
      console.log();
    },
    ///树节点选中状态
    treeCheck(data, list) {
      //data 该节点所对应的对象、list 树目前的选中状态对象
      //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点
      //单选实现
      if (list.checkedKeys.length > 0) {
        //单选实现
        this.$refs.tree.setCheckedKeys([data.id])
      } else {
        //取消当前选中节点
        this.$refs.tree.setCheckedKeys([])
      }
    },

    // 搜索逻辑
    // filterMethod(value, data) {
    //   if (!value) return true
    //   return data.label.indexOf(value) !== -1
    // },
    // 
    getOrgTree() {
      var _this = this // 记录vuecomponent
      login.getOrgs().then(response => {
        this.includeDepts = response.result

        _this.orgsTree = listToTreeSelect(response.result)
        console.log(_this.orgsTree);
        window.localStorage.setItem('department', JSON.stringify(this.orgsTree))


      })


    },
    handleNodeClick(data, node, elem) {
      if (!window.localStorage.getItem('modules')) {
        this.getOrgTree()
        store.dispatch('GetModulesTree').then(modules => { // 获取用户可访问的模块
          store.dispatch('GenerateRoutes', { modules }).then(() => { // 根据权限生成可访问的路由表                     
          })
        })

      }

      window.localStorage.setItem('Currentdepartment', JSON.stringify(data))
      if (this.includeDepts && this.includeDepts.length > 0) {
        var deptinfo = this.includeDepts.filter(x =>
          x.deptCode == data.deptCode
        )

        if (deptinfo.length > 0 && deptinfo[0].isDept === 'Y') {

          login.getDept({
            code: deptinfo[0].deptCode
          }).then(res => {
            var orginfo = this.includeDepts.filter(x => x.id == deptinfo[0].orgId)
            // console.log(orginfo);
            // console.log(orginfo);
            // console.log(deptinfo);
            this.$store.dispatch('SET_DEFAULTORG', orginfo)
            this.$store.dispatch('SetDetpInfo', deptinfo)
            this.$router.push({
              path: '/'
            })
          })
        }

      }
    },
    // 递归找出选择科室及所有上级科室的data指定属性（如title、id）
    findTreeParentDataAttr(node, attrName, parentNameArr) {
      if (!parentNameArr) {
        parentNameArr = [];
      }
      // 因为是一层一层往上找，这里把父节点放最前面
      parentNameArr.unshift(node.data[attrName]);
      if (node.data.id == '0') {// 根节点

      } else {
        this.findTreeParentDataAttr(node.parent, attrName, parentNameArr);
      }
      // 返回找到的所有节点名称
      return parentNameArr;
    },

    searchChild() {

      const that = this;
      //深拷贝防止改变源数据
      let sourceDto = JSON.parse(JSON.stringify(that.orgsTree))
      if (that.filterText) {

        that.arr = that.childrenFn(sourceDto, that.filterText);

      } else {

        this.getOrgTree()
      }
    },
    /**
       * @param arr 传入的树结构
       * @param key 需要搜索的关键字
       */
    childrenFn(arr, key) {
      // console.log(arr);
      const that = this;
      let searchTree = [];
      arr.forEach((item) => {

        if (item.children != undefined && item.children.length != 0) {
          // console.log(key);
          let leaf = that.childrenFn(item.children, key);
          // console.log(leaf);
          //如果叶子节点为空，说明没找到，去找一下叶子节点的上一级
          if (leaf != undefined) {
            let { label, id } = item;
            let parentObj = {
              id, label, children: leaf
            };

            searchTree.push(parentObj);
            // console.log(parentObj);
            // console.log(searchTree);
            this.orgsTree = searchTree
          } else {
            debugger
            //如果是中间节点有关键字，把中间节点作为叶子节点往回传
            if (item.name.indexOf(key) != -1) {
              delete item["children"];
              searchTree.push(item);
            }

          }
        } else {
          //如果是最后一级，回传
          if (item.name.indexOf(key) != -1) {
            searchTree.push(item);
            console.log(searchTree);
          }
        }
      });
      if (searchTree != undefined && searchTree.length != 0) {
        return searchTree
      }
      console.log(searchTree);
      // this.orgsTree
    }



  },
  created() {
    var _this = this // 记录vuecomponent
    // console.log('window',!window.localStorage.getItem('modules'))
    // if(!window.localStorage.getItem('modules')){
    // removeToken()
    // window.location.href = window.location.origin + "/#/login"
    // location.reload();
    // }


  },
  destroyed: {


  },
  computed: {
    ...mapGetters(['defaultorgid', 'name'])
  },
  mounted() {

    this.getOrgTree()

  },
  watch: {

    filterText(val) {


    }
  }
}
</script>

<style lang="less" scoped>
.body {
  padding: 0;
  margin: 0;
  height: 100%;
  padding-top: 2em;
  // background-color: #f5f5f5 !important;
  // background-color: #0093E9;
  // background-image: linear-gradient(160dxeg, #0093E9 0%, #80D0C7 90%);
  background-color: #f7f7f7;

}

.body .el-input__inner {
  color: #000 !important;
}

.swiper {
  width: 100vw;
  height: 200px;
}

.company {

  padding: 30px;
  padding-top: 10px;
  border-radius: 20px;
  margin-top: 15px;
  margin-left: 5vw;
  margin-right: 5vw;
}

.company-line {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.list {
  display: flex;
  flex-wrap: wrap;
  /*justify-content:space-between;*/
}

.node {
  width: 200px;
  height: 150px;

  background-color: #0093E9;
  background-image: linear-gradient(209deg, #0093E9 0%, #80D0C7 100%);


  margin: 15px;
  padding: 15px;
  position: relative;

}

.node-name {
  font-size: 18px;
  font-weight: bold;
}

.node-summary {
  font-size: 14px;
  margin-top: 10px;
}

.node-enter {
  position: absolute;
  bottom: 15px;
  font-size: 12px;
  color: #888888;
}

.contetn {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

}

.content-small {
  /* display: flex;
    flex-wrap: wrap; */

  width: 100%;

}


.Ytitle {
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 20px;
}

.conten-body {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  cursor: pointer;
  font-size: 24px;
  padding: 20px;
  height: 130px;
  margin: 10px;
  border-radius: 10px;
  background-color: #fff;
  color: #000;
  box-shadow: 0px 1px 10px 1px #ccc;

  .bobobo {
    display: flex;
    flex-wrap: wrap;
    width: 240px;
    /* flex: 25%; */
  }
}

.conten-body:hover {
  cursor: pointer;
  transition: all 0.5s;
  transform: scale(1.01);
  font-size: 30px;
  box-shadow: 0px 1px 20px 1px #ccc;
  // background-color: #0093E9;
  // background-image: linear-gradient(209deg, #0093E9 0%, #80D0C7 100%);
  color: #000;
}


.filtertitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 999;
  top: 0;
  font-size: 24px;
  background-color: #1059D6;
  width: 100%;
  text-align: center;
  color: #fff;
  font-weight: 600;
  /* padding: 10px; */

}

.boten {

  display: flex;
  // justify-content: center;
  // align-items: center;
  flex-wrap: wrap;
  width: 100vw;
  padding: 0 20px;
  margin: auto;
  margin-top: 60px;


}

.center {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100vw;
}
</style>